<template>

<div>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page-heading -->
		<page-heading :show="true" pageTitle="CONTENT_POOL-SETTINGS"></page-heading>

		<div class="columns">

			<div class="col-main">

				<tabs type="boxed">

					<!-- tab: ALLGEMEINES -->
					<tab-item label="Allgemeines">
						<form-input inputType="text" label="CONTENT_POOL-SETTINGS-FB_NAME" v-model="name.data" :is-horizontal="false"></form-input>
	                    <form-input inputType="text" label="CONTENT_POOL_SETTINGS-FB_ID" v-model="id.data" :is-horizontal="false"></form-input>

						<div class="tabButtons">
							<custom-button type="blue" size="small" icon="icon-ak-speichern" name="COMPLAT-SETTINGS-BTN-SAVE" :loading="isSaving" @click.native="submitForm()" :class="{'is-disabled': isReadOnly}"></custom-button>
						</div>

					</tab-item>

					<!-- tab: NEWSLETTER VERSAND -->
					<tab-item label="Newsletter Versender">

						<div v-for="(sender, index) in newsletterSender" class="columns sender">

							<div class="column is-narrow">
								<!-- <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getAsset(sender.asset)"></div> -->
								<vue-dropzone
									:ref="'vueDropzone-'+index"
									:id="'vueDropzone-'+index"
									url= "fileProcessing/upload?preset=person"
									:maxFiles="1"
									:thumbnailWidth="100"
									:thumbnailHeight="80"
									acceptedFiles= ".jpg,.jpeg,.png,.gif"
									:dictDefaultMessage="`<i class='fa fa-cloud-upload'></i>` + $t('USER_ACCOUNT-UPLOAD_AVATAR')"
									v-on:vdropzone-removed-file="dzRemoveFile(index)"
									v-on:vdropzone-mounted="dzInit(index)"
									v-on:vdropzone-success="dzSuccess($event, index)" class="dzSingle">
								</vue-dropzone>

							</div>

							<div class="column is-narrow">
								<form-input inputType="text" minWidth="350px" label="COMPLAT-SETTINGS-NEWSLETTERSENDER-NAME" v-model="sender.name"></form-input>
							</div>

							<div class="column">
								<!-- <form-input inputType="text" minWidth="350px" label="COMPLAT-SETTINGS-NEWSLETTERSENDER-ROLE" v-model="sender.role"></form-input> -->
								<form-input inputType="textarea" minWidth="350px" textareaRows="3" label="COMPLAT-SETTINGS-NEWSLETTERSENDER-SIGNATURE" v-model="sender.signature"></form-input>
							</div>

							<div class="column is-narrow">

								<pop-confirm :class="['icon is-small has-pointer']" content="Möchten Sie diese Person wirklich entfernen?" icon="question-circle-o" cancel-text="nein" :on-ok="function() { newsletterSenderRemove(index) }">
									<i class="fa icon-ak-entfernen" title="Newsletter Sender entfernen"></i>
								</pop-confirm>

							</div>

						</div>

						<div class="tabButtons">
							<custom-button type="blue" icon="icon-ak-hinzufuegen" size="small" name="COMPLAT-SETTINGS-NEWSLETTERSENDER-BTN-ADD" @click.native="newsletterSenderAdd"></custom-button>
							<custom-button type="blue" icon="icon-ak-speichern" size="small" name="COMPLAT-SETTINGS-BTN-SAVE" :loading="isSaving" @click.native="newsletterSenderSave"></custom-button>
						</div>

						<!--
						<pre>
							{{ newsletterSender }}
						</pre>
						-->

					</tab-item>

			    </tabs>

			</div>

			<!--
	        <div class="col-aside">

				<affix :offset="50">
		            <div class="sidebox">
						<custom-button type="blue" icon="icon-ak-speichern" name="CPT-BTN-SAVE" :loading="isSaving" @click.native="submitForm()" :class="{'is-disabled': isReadOnly}"></custom-button>
					</div>
				</affix>

	        </div>
			-->

	    </div>

	</template>

</div>
</template>



<script>
import vueDropzone from '../../../utils/dropzoneWrapper';

export default {

    name: 'contentPoolSettings',

	components: {
		vueDropzone,
	},

	data() {

		return {
			isSaving: false,
			isLoading: true,
			fbAccessToken: null,
            name: {},
            id: {},
			newsletterSender: [],
			userRoles: [],
		}
	},


	created() {

        this.fetchData();

	},

    computed: {

    },

	mounted() {

	},

	update() {

	},

	methods: {

		dzInit(index) {


			if(this.newsletterSender[index].asset != null) {
				// console.log(this.$refs);
				var url = this.$config.assets + this.newsletterSender[index].asset.path + '/' + this.newsletterSender[index].asset.filename;
				var mockFile = { id: 'avatar', name: this.newsletterSender[index].asset.filename }

				// add mockFile to our dropzone
				let name = 'vueDropzone-'+index;

				this.$refs[name][0].$children[0].manuallyAddFile(mockFile, url);

			}

		},


		dzSuccess(file, index) {

			var result = JSON.parse(file.xhr.response);

			this.newsletterSender[index].asset = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

			// var self = this;
			// this.$refs.vueDropzone.removeAllFiles()
			// this.dzInit();

		},

		dzRemoveFile(index) {

			this.newsletterSender[index].asset = null;

		},



		newsletterSenderAdd() {

			let obj =  {
				name: "",
				signature: "",
				role: null,
				asset: null
			}

			this.newsletterSender.push(obj);

		},


		newsletterSenderRemove(index) {

			this.newsletterSender.splice(index, 1);

		},

		newsletterSenderSave() {

			this.entityCreateOrUpdate('newsletterSender', this.newsletterSender);

		},

		fetchData() {

			this.isLoading = true;
			var self = this;

            function getFB_ID() {
                return self.axios.get(self.$config.api + 'setting?filters[name]=ContentPool.FacebookPageId');
            }
            function getFB_NAME() {
                return self.axios.get(self.$config.api + 'setting?filters[name]=ContentPool.FacebookAuthorName');
            }
			function getNewsletterSender() {
				return self.axios.get(self.$config.api + 'newsletterSender?include=newsletterSender.asset');
			}
			function getUserRoles() {
				return self.axios.get(self.$config.api + 'userRole');
			}

			this.axios.all([getFB_ID(),getFB_NAME(),getNewsletterSender(), getUserRoles()])
				.then(self.axios.spread(function (fbID, fbName, newsletterSender, userRoles) {

					self.name = fbName.data.setting[0];
					self.id = fbID.data.setting[0];
					self.newsletterSender = newsletterSender.data.newsletterSender;
					self.userRoles = userRoles.data.userRole;

          self.isLoading = false;

				})).catch(function(error) {
					console.log("ERROR: ", error);
				});

		},

		getAsset(asset, thumb=false) {

			if(asset == null) {
				return "";
			}

			return this.$config.assets + asset.path + '/' + (thumb == true ? 'thumb/' : '' ) + asset.filename;
			// return this.$config.assets + asset.asset.path + '/' + (thumb == true ? 'thumb/' : '' ) + asset.asset.filename;

		},


		submitForm() {

            var self = this;
			this.isSaving = true;

			this.entityCreateOrUpdate('setting', this.name, { isSilent: true })
				.then(function(response) {

					self.fbLogin();
					/*
					if(self.fbAccessToken == null) {
                    	self.fbLogin();
					} else {
						// self.isSaving = false;
						self.saveToken(self.fbAccessToken);
					}
					*/

				});

		},

        fbLogin() {

            var self = this;

			// Load the SDK Asynchronous
	        (function(d, s, id) {
	            var js, fjs = d.getElementsByTagName(s)[0];
	            if (d.getElementById(id)) {return;}
	            js = d.createElement(s); js.id = id;
	            js.src = "https://connect.facebook.net/en_US/sdk.js";
	            fjs.parentNode.insertBefore(js, fjs);
	        }(document, 'script', 'facebook-jssdk'));

            window.fbAsyncInit = function() {

                FB.init({
                    appId: '933884696790336',
                    xfbml: true,
                    cookie: true,
                    version: 'v2.12'
                });

                FB.getLoginStatus(function(response) {

                    if (response.status === 'connected') {

						console.log("already connected ...");
                        self.saveToken(response.authResponse.accessToken);

                    } else {

						console.log("not connected ...");

                        FB.login(function(response) {

                            if(response.authResponse) {
                                self.saveToken(response.authResponse.accessToken);
                            } else {
								console.log("autsch");
								self.isSaving = false;
                            }

						}, {
						    scope: 'publish_pages,manage_pages',
						    return_scopes: true
						});

                    }

                }, true);

            }
        },

        saveToken(token=null) {

			if(token == null) {
				this.$notify.open({content: 'es wurde kein Accesstoken übergeben', type: 'warning' });
				return;
			}

            var self = this;

            let obj =  {
                pageId: this.id.data,
                shortLivedUserToken: token
            }

            this.entityCreateOrUpdate('articleVariant/updateFacebookPageId', obj)
                .then((response) => {
					self.fbAccessToken = token;
                    self.isSaving = false;
                })

        }

	}

}

</script>


<style lang="scss" scoped>

	@import '../../../../assets/css/variables.scss';

	.columns.sender {
		background: $themeTblCellEvenColor !important;
	}

</style>

<style scoped>

	.columns.sender {
		margin-bottom: 15px;
	}

	.sender .dzSingle {
		min-width: 100px !important;
		width: 100px !important;
		min-height: 75px !important;
		height: 75px !important;
	}

	.sender .dzSingle >>> .dz-message span i {
		font-size: 24px;
	}
	.sender .dzSingle >>> .dz-message {
		font-size: 9px !important;
		white-space: normal;
		line-height: 1.2em;
	}

	/*
	.sender .imgWrapper {
		background-repeat: no-repeat;
		background-position: 50% 50% !important;
		background-size: cover;
		width: 100px;
		height: 80px;
		margin: 0;
		background-color: #FFF;
		border: 1px solid #efefef;
		border-radius: 2px;
	}
	.sender .imgWrapper[lazy=loading]  {
		background-size: 30% !important;
	}
	.sender .imgWrapper[lazy=error]  {
		background-size: contain !Important;
	}
	*/



</style>
